import React from "react"

import ItemDetailsColumns from "../../../common/columns/ItemDetailsColumns"
import ItemDetailsColumn from "../../../common/columns/ItemDetailsColumn"
import type { Stakeholder } from "../../../../types/types"
import StakeholderRelationshipsViewWidget from "../../../common/StakeholderRelationshipsViewWidget"
import StakeholderViewItemDetails from "./StakeholderViewItemDetails"

type Props = {
    model: Stakeholder,
    isFetching: boolean,
    onValueChange: void => void
}

const StakeholderViewItem = ({ model, isFetching, onValueChange }: Props) => (
    <ItemDetailsColumns>
        <ItemDetailsColumn>
            <StakeholderViewItemDetails
                bio={model.bio}
                full_name={model.full_name}
                last_name={model.last_name}
                status={model.status}
                primary_organisation={model.primary_organisation}
                primary_position={model.primary_position}
                photo_url={model.photo_url}
                type={model.type}
                isFetching={isFetching}
            />
        </ItemDetailsColumn>
        <ItemDetailsColumn>
            <StakeholderRelationshipsViewWidget isFetching={isFetching} />
        </ItemDetailsColumn>
    </ItemDetailsColumns>
)

export default StakeholderViewItem
